import React, { Component } from 'react';
import { View, StyleSheet, FlatList } from 'react-native';
import { keyExtractor } from '../utils/BreadCrumbUtils';
import { getTextMaxWidth } from '../utils/getStyle';
import EventText from '../commonComponents/EventText';
import IndexIndicator from '../commonComponents/IndexIndicator';
import { DRNUtil } from '@traveloka/district-util';
import R from '../../../core-res/R';
import { HORIZONTAL_LINE_LENGTH, ITEM_MAX_LENGTH } from '../utils/BreadCrumbConst';
class HorizontalBreadCrumb extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            webTextWidth: 0,
        };
        this.getWebTextMaxWidth = () => {
            if (this.state.webTextWidth)
                return this.state.webTextWidth;
            return;
        };
        this.measureWidth = e => {
            const { width } = e.nativeEvent.layout;
            !this.state.webTextWidth &&
                this.setState({
                    webTextWidth: width - 2 * HORIZONTAL_LINE_LENGTH - 4 * R.spacing.s,
                });
        };
        this.renderHorizontalLine = () => {
            const { theme } = this.props;
            return <View style={[styles.horizontalLine, { backgroundColor: theme.lightPrimary }]}/>;
        };
        this._renderItem = ({ item, index }) => {
            const { activeEventIndex, events, theme } = this.props;
            const lastItemIndex = events.length - 1;
            const maxWidth = ITEM_MAX_LENGTH;
            const textMaxWidth = DRNUtil.isWeb() ? this.getWebTextMaxWidth() : getTextMaxWidth(index, lastItemIndex);
            return (<View style={[styles.listItem, { maxWidth }]}>
        <IndexIndicator theme={theme} activeEventIndex={activeEventIndex} index={index}/>
        <View style={{ maxWidth: textMaxWidth }}>
          <EventText theme={theme} numberOfLines={1} activeEventIndex={activeEventIndex} text={item} index={index}/>
        </View>
        {index < lastItemIndex && this.renderHorizontalLine()}
      </View>);
        };
    }
    render() {
        const { theme, events } = this.props;
        return (<View key={theme.lightPrimary} onLayout={this.measureWidth} style={{ backgroundColor: theme.brand, paddingHorizontal: R.spacing.s }}>
        <FlatList horizontal keyExtractor={keyExtractor} data={events} renderItem={this._renderItem} snapToAlignment="start" decelerationRate="fast" extraData={this.state} showsHorizontalScrollIndicator={false}/>
      </View>);
    }
}
const styles = StyleSheet.create({
    listItem: {
        flexDirection: 'row',
        paddingVertical: R.spacing.xs,
    },
    horizontalLine: {
        height: 2,
        width: HORIZONTAL_LINE_LENGTH,
        alignSelf: 'center',
        marginHorizontal: R.spacing.s,
    },
});
export default HorizontalBreadCrumb;
